<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalRenameFile">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><b><i class="fa fa-edit"></i> Renomear arquivo</b></p>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <required /> <label>Nome</label>
                                <input v-model="file.arquivo_nome" :class="{ 'is-invalid': errors.has('Nome') }" name="Nome" v-validate="{required: true}" id="Nome"
                                    :placeholder="$t('words.type_description')" class="form-control">
                                <div class="invalid-feedback help-block error">{{errors.first('Nome')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" @click="saveFile()" :disabled="loading" class="btn btn-success float-right"><i
                            class="fa fa-check"></i>
                        {{$t('words.save')}} <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                file: {
                    arquivo_nome: null,
                    id: null,
                }
            }
        },
        methods: {
            saveFile() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.renameFile();
                    }
                });
            },
            renameFile() {
                this.loading = true;
                this.$store.dispatch('renameFile', this.file).then(response => {
                    console.log(response);
                    toastr({
                        icon: 'success',
                        title: 'Renomeado com sucesso!'
                    });
                    this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                    $('#ModalRenameFile').modal('toggle');
                }).catch(error => {
                    console.log(error);
                    toastr({icon: error.response.data.status, title: error.response.data.message});
                }).finally(f => {
                    this.loading = false;
                })
            },
        }
    }
</script>